<template>
  <div class="dnd-campaign-gen">    
    <h1><span class="emoji-class--big">⚔</span> DND Campaign Generator <span class="emoji-class--big">⚔</span></h1>
    <img src="../assets/wizardHat.svg" class="goblin" />
    <h1>Your Party</h1>
    <div class="character-info">
      <div class="character-desc" v-for="(charObj, index) in characters" :key="`charObj-${index}`">
        <div v-if="!generating">
          <p>{{ charObj.name }}</p>
          <p>{{ charObj.race }}</p>
          <p><span class="emoji-class">{{ charObj.classEmoji }}</span> {{charObj.class}} <span class="emoji-class">{{ charObj.classEmoji }}</span></p>
        </div>
        <img src="../assets/d20.svg" class="d20" v-if="generating"/>
      </div>
    </div>
    <div class="bio">
      <h1>Are Adventuring In This Campaign</h1>
      <div v-if="generating">
        <img src="../assets/books.svg" class="goblin"/>
        <p><span class="emoji-class">⚔</span> Generating a campaign <span class="emoji-class">⚔</span></p>
      </div>
      <p v-if="!generating">{{ campaignSummary }}</p>
    </div>
    
    <div class="temp-generation">
      <label for="temp-select">🔥 Generation Temperature 🔥 </label>
      <select v-if="options" :v-model="temp" class='selector' id="temp-select" @input="clicked" >
        <option 
          v-for="option in options"
          :key="option.key"
          :value="option.value"
        >
          {{ option.value }}
        </option>
      </select>
    </div>

    <button v-on:click="regenerate" v-if="generating">
      <img src="../assets/d20.svg" class="d20"/>
      <img src="../assets/d20.svg" class="d20"/>
      <img src="../assets/d20.svg" class="d20"/>
    </button>
    <button v-on:click="regenerate" v-if="!generating">Generate Campaign</button>
    
    
    
    <span class="emoji-class--big-block">⚔</span>
  </div>
</template>

<script>
  
  import names from '../lib/generatedNames.js';
  import temp9CampaignSummaries from '../lib/temp9CampaignSummaries.js';
  import temp7CampaignSummaries from '../lib/temp7CampaignSummaries.js';
  import temp12CampaignSummaries from '../lib/temp12CampaignSummaries.js';
  import temp15CampaignSummaries from '../lib/temp15CampaignSummaries.js';
  
  export default {
    name: 'DndCampaignGenerator',
    data() {
      return {
        characters: [],
        partySize: 4,
        campaignSummary: undefined,
        temp: 0.7,
        options: undefined,
        generating: true
      }
    },
    mounted() {
      this.options = [{key: 7, value: "0.7"}, {key: 9, value: "0.9"}, {key: 1.2, value: "1.2"}, {key: 1.5, value: "1.5"}];

      for(var i = 0; i < this.partySize; i++) {
        this.characters.push(this.buildCharacter(this.pickCharacter()));
      }
    
      this.campaignSummary = this.pickCampaignSummary();
      this.showLoader(100, 500);
    },
    methods: {
      showLoader(min, max) {
        setTimeout (
          () => this.generating = false,
          Math.random() * (max - min) + min
        );
      },
      clicked($event) {
        this.temp = $event.target.value;
      },
      regenerate() {
        this.generating = true;
        this.bio = null;
        this.characters = [];

        for(var i = 0; i < this.partySize; i++) {
          this.characters.push(this.buildCharacter(this.pickCharacter()));
        }
        this.campaignSummary = this.pickCampaignSummary();
        this.showLoader(100, 500);
      },
      pickCharacter() {
        return names[Math.floor(Math.random() * names.length)];
      },
      pickCampaignSummary() {
        let startingPoint = 0;
        let summary = '';
        let set;
        if (this.temp == '0.7') {
          console.log('temp7 generation');
          set = temp7CampaignSummaries;
        } else if (this.temp == '0.9') {
          console.log('temp9 generation');
          set = temp9CampaignSummaries;
        }
        else if (this.temp == '1.2') {
          console.log('temp1.2 generation');
          set = temp12CampaignSummaries;
        }
        else {
          console.log('temp1.5 generation');
          set = temp15CampaignSummaries;
        }
        startingPoint = Math.floor(Math.random() * set.length-2);
        summary += set[startingPoint+1];
        summary += set[startingPoint+2];
        console.log(summary);
        return summary;
      },
      buildCharacter(character) {
        let charParts = character.split(',');
        
        let charObj = {
          name: charParts[0] != null ? charParts[0] : '',
          race: charParts[1] != null ? charParts[1] : '',
          class: charParts[2] != null ? charParts[2] : '',
          classEmoji: charParts[2] != null ? this.getClassEmoji(charParts[2]) : '',
        };
        return charObj;
      },
      addClassEmoji(characterClass) {
        return `${this.getClassEmoji(characterClass)} ${characterClass} ${this.getClassEmoji(characterClass)}`;
      },
      getClassEmoji(characterClass) {
          switch(characterClass.toLowerCase()) {
            case 'sorcerer':
            case 'sorceress':
            case 'wizard':
              return '🧙‍♀️';
            case 'warrior':
            case 'barbarian':
              return '🛡⚔️';
            case 'fighter':
              return '👊🏽';
            case 'bard':
              return '🎭 🪕';
            case 'rogue':
              return '🤺';
            case 'paladin':
              return '🛡';
            case 'monk':
              return '🧘🏿‍♀️';
            case 'thief':
              return '🤏';
            case 'ranger':
              return '🥾';
            case 'druid':
              return '🌱';
            case 'shaman':
              return '🧙‍♀️';
            case 'cleric':
              return '⛪️';
            case 'warlock':
              return '🧙‍♂️';
            default: 
              return '';
          }
        }
    }
  }
</script>
<style scoped>

  .dnd-campaign-gen {
    text-align: center;
    font-family: 'Press Start 2P', cursive;
    font-size: 14px;
  }

  .goblin {
    width: 6em;
    height: 10em;
    padding-bottom: 0em;
  }

  .d20 {
    align-self: center;
    height: 50px;
    width: 50px;
    animation: roll 1.6s infinite;
    transform: rotate(30deg);
  }
  
  @keyframes roll {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  button {
    font-family: 'Press Start 2P', cursive;
    font-size: 14px;
    padding: 0.5em;
    width: 22em;
    height: 5em;
    color: #565656;
    border: none;
    background: white;
    border: 1px solid #565656;
    cursor: pointer;
  }

  button:hover {
    color: black;
    border-bottom: 3px solid black;
    font-weight: bold;
  }

  .temp-generation {
    display: block;
    padding-top: 1em;
    padding-bottom: 1em;
  }

  .selector {
    font-family: 'Press Start 2P', cursive;
    font-size: 14px;
    padding: 0.5em;
    width: 5.5em;
    height: 4em;
    color: #565656;
    border: none;
    background: white;
    border: 1px solid #565656;
  }

  h1 {
    color: black;
  }

  .character-info {
    border-bottom: 1px solid black;
    display: flex;
    font-size: 16px;
  }

  .character-desc {
    width: 25%;
  }

  .bio {
    padding: 1.5em;
    padding-bottom: 2em;
    line-height: 1.6;
  }

  .emoji-class {
    font-size: 24px;
  }

  .emoji-class--big {
    font-size: 40px;
  }

  .emoji-class--big-block {
    font-size: 40px;
    display: block;
    padding-top: 0.5em;
  }

   @media screen and (max-width: 500px) {
    .emoji-class--big {
      display: block;
    }
    button {
      display: block;
    }
    
   }

  @media screen and (max-width: 700px) {
    .emoji-class--big {
      display: block;
    }
    .character-desc {
      display: block;
    }
  }
</style>